import { Routes, Route, Navigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useAuth } from "./context/AuthContext";
import Sidebar from "./Components/Sidebar";
import LoginPage from "./Components/LoginPage";
import ProtectedRoute from "./Components/ProtectedRoute";
import Client from "./Pages/Client";
import Application from "./Pages/Application";
import Environments from "./Pages/Environments";
import LogicalGroups from "./Pages/LogicalGroups";
import AlternativeNames from "./Pages/AlternativeNames";
import Documents from "./Pages/Documents";
import Connectors from "./Pages/Connectors";
import Jobs from "./Pages/Jobs";
import Substage from "./Pages/Substage";
import Schedule from "./Pages/Schedule";
import Box from "@mui/material/Box";
import "./App.css";
import JobMonitoring from "./Pages/JobMonitoring";
import FailureTracking from "./Pages/FailureTracking";
import ProcessMonitoring from "./Pages/ProcessMonitoring";
import ServiceStatus from "./Components/Servicestatus";
import Home from "./Pages/Home";
import Reports from "./Pages/GarpacReports";
import FailureTrackingReports from "./Pages/FailureTrackingReports";
import JobMonitoringReports from "./Pages/JobMonitoringReports";
import Tickets from "./Pages/Aging&Tickets";
import ConnectorsEndpointsPlaybooks from "./Pages/ConnectorsEndpointsPlaybooks";
const App = () => {
  const { isAuthenticated, loading } = useAuth();
  const [serviceDown, setServiceDown] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    // Use the API base URL for the service check
    const API_BASE_URL =
      process.env.REACT_APP_API_BASE_URL || "http://localhost:8080";

    fetch(`${API_BASE_URL}/dbconnect`)
      .then((res) => {
        if (!res.ok) throw new Error("Service Unavailable");
        setServiceDown(false);
      })
      .catch((error) => {
        console.log("Service check failed:", error);
        // Don't block the app if service check fails - just log it
        setServiceDown(false);
      })
      .finally(() => setChecking(false));
  }, []);

  // Show loading while checking auth or service status
  if (loading || checking) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  // Show service status if service is down
  if (serviceDown) {
    return <ServiceStatus />;
  }

  // Show login page if not authenticated
  if (!isAuthenticated()) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  // Show main app if authenticated and service is up
  return (
    <Box sx={{ display: "flex", height: "100vh", overflow: "hidden" }}>
      <Sidebar />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          marginLeft: "80px", // Match sidebar width exactly
          marginTop: "60px", // topbar height
          height: "calc(100vh - 60px)",
          overflow: "auto",
          minWidth: 0, // Allow content to shrink properly
          p: 2,
        }}
      >
        <Routes>
          <Route path="/login" element={<Navigate to="/home" replace />} />
          <Route path="/" element={<Navigate to="/home" replace />} />
          <Route
            path="/client"
            element={
              <ProtectedRoute>
                <Client />
              </ProtectedRoute>
            }
          />
          <Route
            path="/home"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />
          <Route
            path="/application"
            element={
              <ProtectedRoute>
                <Application />
              </ProtectedRoute>
            }
          />
          <Route
            path="/environments"
            element={
              <ProtectedRoute>
                <Environments />
              </ProtectedRoute>
            }
          />
          <Route
            path="/logicalgroups"
            element={
              <ProtectedRoute>
                <LogicalGroups />
              </ProtectedRoute>
            }
          />
          <Route
            path="/alternativenames"
            element={
              <ProtectedRoute>
                <AlternativeNames />
              </ProtectedRoute>
            }
          />
          <Route
            path="/documents"
            element={
              <ProtectedRoute>
                <Documents />
              </ProtectedRoute>
            }
          />
          <Route
            path="/jobs"
            element={
              <ProtectedRoute>
                <Jobs />
              </ProtectedRoute>
            }
          />
          <Route
            path="/substage"
            element={
              <ProtectedRoute>
                <Substage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/schedule"
            element={
              <ProtectedRoute>
                <Schedule />
              </ProtectedRoute>
            }
          />
          <Route
            path="/jobmonitoring"
            element={
              <ProtectedRoute>
                <JobMonitoring />
              </ProtectedRoute>
            }
          />
          <Route
            path="/failuretracking"
            element={
              <ProtectedRoute>
                <FailureTracking />
              </ProtectedRoute>
            }
          />
          <Route
            path="/processmonitoring"
            element={
              <ProtectedRoute>
                <ProcessMonitoring />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports"
            element={
              <ProtectedRoute>
                <Reports/>
              </ProtectedRoute>
            }
          />
          <Route
            path="/failure-tracking-reports"
            element={
              <ProtectedRoute>
                <FailureTrackingReports />
              </ProtectedRoute>
            }
          />
          <Route
            path="/job-monitoring-reports"
            element={
              <ProtectedRoute>
                <JobMonitoringReports />
              </ProtectedRoute>
            }
          />
          <Route
            path="/connectors"
            element={
              <ProtectedRoute>
                <Connectors />
              </ProtectedRoute>
            }
          />
          <Route
            path="/connectors-endpoints-playbooks"
            element={
              <ProtectedRoute>
                <ConnectorsEndpointsPlaybooks />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tickets"
            element={
              <ProtectedRoute>
                <Tickets />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Box>
    </Box>
  );
};

export default App;
